import "./modules/header";
import "./modules/menu";
import "./modules/footer";
import "./modules/form-counrty-code-to-flag";
import "./modules/skip-link";
import "./modules/youtube-video-tracker";

window.addEventListener("load", function () {
  window.dispatchEvent(new Event("resize"));
  var tag = document.createElement("script");
  tag.setAttribute("async", "async");
  tag.src = "//js.hsforms.net/forms/embed/v2.js";
  document.getElementsByTagName("footer")[0].appendChild(tag);
});
